<template>
  <div class="passwordreset-view">
    <header-view />
    <div class="box">
      <div class="sign-box">
          <h1>Reset Your Password</h1>
          <h3>Enter the email associated with your Healthy School Buildings account and we'll send you instructions to reset your password.</h3>
          <div class="form-wrapper">
            <div class="form-group">
                <input type="text" class="form-control" v-model="email" placeholder="Email"/>
            </div>
          </div>
          <div class="form-wrapper">
            <router-link :to="{ name: 'login' }" class="btn secondary">Cancel</router-link>
            <button type="submit" class="btn" @click="reset">Submit</button>
          </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.passwordreset-view {
  background: #bfb6b7;
}
.box {
  background: white;
  border-radius: 10px;
  margin: 130px 20px 0;
  position: relative;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}
.form-wrapper .btn {
  margin-right: 20px;
}
.brand {
  text-align: center;
  position: relative;
  padding: 20px;
}
.brand img {
  position: relative;
  top: 25%;
  max-width: 100%;
}
.sign-box {
  background: #6e5f60;
  color: #fff;
  padding: 20px;
  border-radius: 10px;
}
.sign-box h1 {
  padding-top: 0;
}

.form-group {
  margin: 0 0 20px;
}
.sign-box input {
  border: 0;
  height: 2.5rem;
  font-size: 1rem;
  padding-left: 1rem;
  border-radius: 5px;
  width: 100%;
  display: flex;
  box-sizing: border-box;
}
@media only screen and (min-width: 1028px) {
  .sign-box {
    padding-left: 260px;
  }
  .box {
    width: 960px;
  }
}
@media only screen and (min-width: 680px) {
  .login-view {
    height: 100%;
  }
  .box {
    top: 150px;
    margin: 30px auto 0;
  }
  .brand {
    height: 300px;
  }
  .brand img {
    position: relative;
    top: 25%;
  }
  .sign-box h1 {
    padding-top: 35px;
  }
  .sign-box {
    background: #6e5f60;
    color: #fff;
    min-height: 200px;
    padding:10% 15%;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .form-wrapper {
    display: flex;
  }
  .form-group {
    margin: 0 0 20px;
  }
}

</style>

<script>
import firebase from '@firebase/app'
import '@firebase/auth'
import HeaderView from '@/components/HeaderView.vue'

export default {
  name: 'PasswordReset',
  components: {
    HeaderView
  },
  data () {
    return {
      email: ''
    }
  },
  beforeCreate: function() {
    document.body.classList.add('login')
  },
  beforeDestroy: function() {
    document.body.classList.remove('login')
  },
  mounted () {
    document.body.classList.add('login')    
  },
  methods: {
    reset () {
      firebase.auth().sendPasswordResetEmail(this.email).then(
        () => {
          this.email = ''
        },
        (error) => {
          alert(error.message)
        }
      )
    }
  }
}
</script>
